import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ProductResponseModel, ProductSort, ProductTypeSort } from 'src/app/models/Home/home-list.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductNameComponent } from '../product-name/product-name.component';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  pagingModel: PagingModel = new PagingModel();
  totalPages: number;
  Loader: boolean = false;
  homeContentList: ProductTypeSort = new ProductTypeSort();
  localStorage: LocalstorageService;
  homeProductResponseModel: ProductResponseModel = new ProductResponseModel();
  productType: string;

  constructor(private homePageService: HomePageService, private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal, private _localStorage: LocalstorageService) {
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
    this.localStorage = _localStorage;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((param) => {
      this.productType = param.id;
    });
    this.product();

  }

  loadPage(pagingModel: PagingModel) {
    this.homeContentList.PageNumber = pagingModel.pageNumber;
    this.homeContentList.PageSize = pagingModel.pageSize;
    this.product();
  }

  product() {
    this.Loader = true;
    this.homeContentList.ProductType = this.productType;
    this.homePageService.ProductContentList(this.homeContentList)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.homeProductResponseModel.ProductSort = responseBody.responseData;
          this.homeProductResponseModel.ProductSort.forEach((element, index) => {
            this.homeProductResponseModel.ProductSort[index].imageLoader = true;
            this.homePageService.ProductImageList(element.productId)
              .subscribe((response) => {
                let responseimage = JSON.parse(response._body)
                if (responseimage.isSuccess) {
                  this.homeProductResponseModel.ProductSort[index].productImage = responseimage.responseData;
                  this.homeProductResponseModel.ProductSort[index].imageLoader = false;
                } (err) => {
                }
              })
          });
          this.homeProductResponseModel.TotalPages = responseBody.totalPages;
          this.totalPages = this.homeProductResponseModel.TotalPages == undefined ? 0 : this.homeProductResponseModel.TotalPages;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  uploadImage(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + item.productId]));
    window.open('#' + url, '_blank');
  }

  orderConfirm(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + item.productId]));
    window.open('#' + url, '_blank');
  }

  requestQuote(item) {
    if (this.localStorage.getToken()) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/request-quote/' + item.productId]));
      window.open('#' + url, '_blank');
    } else {
      this.router.navigate(['/login'], { queryParams: { return: window.location.origin + '/#/product-page/' + item.productId } });
    }
  }

  shopProductName(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "sm";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(ProductNameComponent, modalConfig);
    modalRef.componentInstance.productTitle = item.productTitle;
  }
}
